import { useState } from "react";
import axios from "axios";
import { AlertTriangle, ArrowRight, Eye, EyeOff, KeyRound, Loader2, ShieldCheck } from "lucide-react";
import { API } from "../../lib/api";

export default function LoginPage({ onLogin }) {
  const [username, setU] = useState("");
  const [password, setP] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);
  const [forgotName, setForgotName] = useState("");
  const [forgotMsg, setForgotMsg] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError(null);
    try {
      const r = await axios.post(`${API}/auth/login`, { username, password });
      onLogin(r.data);
    } catch (err) {
      setError(err?.response?.data?.detail || "Login gagal — periksa username & password");
    } finally { setLoading(false); }
  };

  const submitForgot = async (e) => {
    e.preventDefault();
    setForgotMsg(null);
    try {
      const r = await axios.post(`${API}/auth/forgot-password`, { username: forgotName });
      setForgotMsg({ ok: true, text: r.data?.message || "Permintaan dikirim ke admin." });
    } catch (err) {
      setForgotMsg({ ok: false, text: err?.response?.data?.detail || "Gagal memproses." });
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-bg-orb a" />
      <div className="auth-bg-orb b" />
      <div className="auth-bg-orb c" />
      <div className="auth-grid" />

      <main className="auth-card" data-testid="login-card">
        <div className="auth-brand">
          <div className="auth-logo">
            <ShieldCheck size={22} strokeWidth={2.4} />
          </div>
          <div>
            <h1 className="auth-title">IEU Sales-RM Activity Dashboard</h1>
            <p className="auth-subtitle">Enterprise CRM · Sales · Relationship Management</p>
          </div>
        </div>

        {!forgotOpen ? (
          <form onSubmit={submit} className="auth-form" data-testid="login-form">
            <label className="auth-field">
              <span>USERNAME</span>
              <input
                type="text" value={username} onChange={(e) => setU(e.target.value)}
                autoFocus required maxLength={64} placeholder="Masukkan username"
                data-testid="login-username"
              />
            </label>

            <label className="auth-field">
              <span>PASSWORD</span>
              <div className="auth-pw-wrap">
                <input
                  type={showPw ? "text" : "password"}
                  value={password} onChange={(e) => setP(e.target.value)}
                  required maxLength={200} placeholder="••••••••"
                  data-testid="login-password"
                />
                <button type="button" className="auth-pw-toggle"
                  onClick={() => setShowPw(!showPw)} data-testid="login-toggle-pw"
                  aria-label={showPw ? "Sembunyikan password" : "Tampilkan password"}>
                  {showPw ? <EyeOff size={16}/> : <Eye size={16}/>}
                </button>
              </div>
            </label>

            {error && (
              <div className="auth-error" data-testid="login-error">
                <AlertTriangle size={14}/> {error}
              </div>
            )}

            <button type="submit" className="auth-submit" disabled={loading} data-testid="login-submit">
              {loading ? <><Loader2 size={16} className="spin"/> Memproses...</> : <>Login <ArrowRight size={16}/></>}
            </button>

            <button type="button" className="auth-link" onClick={() => { setForgotOpen(true); setForgotMsg(null); setError(null); }}
              data-testid="login-forgot">
              <KeyRound size={12}/> Lupa password?
            </button>

            <div className="auth-roles">
              <span className="role-chip">Admin</span>
              <span className="role-chip">Manager</span>
              <span className="role-chip">Sales TL</span>
              <span className="role-chip">Sales</span>
              <span className="role-chip">RM</span>
            </div>
          </form>
        ) : (
          <form onSubmit={submitForgot} className="auth-form" data-testid="forgot-form">
            <label className="auth-field">
              <span>USERNAME</span>
              <input type="text" value={forgotName} onChange={(e) => setForgotName(e.target.value)}
                required maxLength={64} placeholder="Masukkan username terdaftar"
                data-testid="forgot-username" autoFocus />
            </label>
            <p className="auth-hint">
              Password baru akan dibuat otomatis & dikirim ke email admin
              (<b>deo.valdo.sidabutar@teachcastglobal.com</b>). Hubungi admin untuk menerima kredensial.
            </p>
            {forgotMsg && (
              <div className={`auth-${forgotMsg.ok ? "success" : "error"}`} data-testid="forgot-result">
                {forgotMsg.text}
              </div>
            )}
            <button type="submit" className="auth-submit" data-testid="forgot-submit">
              <KeyRound size={14}/> Kirim Reset Password
            </button>
            <button type="button" className="auth-link" onClick={() => setForgotOpen(false)} data-testid="forgot-back">
              ← Kembali ke login
            </button>
          </form>
        )}
      </main>
    </div>
  );
}
